import {
    Card,
    CircularProgress,
    Grid,
    Icon,
    IconButton,
    InputAdornment,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
} from '@material-ui/core';
import { AddRounded, MoreHoriz } from '@material-ui/icons';
import clsx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import ScrollBar from 'react-perfect-scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { MatxMenu } from '../../../../../matx';
import { BackdropLoading, TablePagination } from '../../../../components';
import { delDepartementKarir, getDepartementKarir } from '../../../../redux/actions/KarirActions';

const Departement = ({ location }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [page, setPage] = useState('1');
    const [show, setShow] = useState('25');
    const [search, setSearch] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const { departement, loadingDepartement, departementPagination, totalDepartement } = useSelector(
        ({ karir }) => karir
    );

    const getData = useCallback((limit, page, search) => {
        dispatch(getDepartementKarir({limit, page, search}));
    },[dispatch]);

    const showAlert = (text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        });
    };

    const handleDelete = (code, nama) => {
        Swal.fire({
            title: 'Konfirmasi Hapus',
            text: 'Apakah anda yakin ingin menghapus data ' + nama,
            imageUrl: `/assets/images/icons/ic_delete.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Hapus',
            confirmButtonColor: '#FD6D5D',
            showCancelButton: true,
            cancelButtonText: 'Batal',
            cancelButtonColor: '#0083E2',
            reverseButtons: true
        }).then((res) => {
            if (res.isConfirmed) {
                sendDelete(code);
            }
        });
    };

    const sendDelete = (code) => {
        setShowLoading(true);
        delDepartementKarir(code)
            .then(() => {
                getData(show, page, search);
                setShowLoading(false);
                showAlert('Berhasil menghapus data', true);
            })
            .catch((err) => {
                let error = err?.response?.data;
                setShowLoading(false);
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menghapus data, coba beberapa saat lagi',
                    false
                );
            });
    };

    useEffect(() => {
        let params = new URLSearchParams(location?.search);
        let limit = params.get('limit') || '25';
        let cari = params.get('cari') || '';
        let hal = params.get('hal') ? params.get('hal') : '1';
        setShow(limit);
        setPage(hal);
        setSearch(cari);
        getData(limit, hal, cari);
    }, [location.search, getData]);

    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={9} md={10} className="flex items-center">
                    <h3 className="fw-bold m-0">Departement</h3>
                </Grid>
                <Grid item xs={3} md={2}>
                    <Link
                        to="/departement_karir/tambah"
                        className="btn btn-primary border-radius-0 text-white font-14 w-full flex items-center justify-center gap-2"
                        >
                        <AddRounded /> <span className='d-none d-md-block'>Tambah</span>
                    </Link>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Card className="w-full pt-6 pb-4 border-radius-0" elevation={0}>
                        <Grid
                            container
                            spacing={2}
                            className="mb-2 px-6"
                            justifyContent='flex-end'
                        >
                            <Grid item xs={12} md={4}>
                                <form
                                    noValidate
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        history.push(
                                            `/departement_karir?hal=${page}&limit=${show}&cari=${search}`
                                        );
                                    }}
                                >
                                    <TextField
                                        value={search}
                                        placeholder="Cari departement"
                                        variant="outlined"
                                        onChange={({ target: { value } }) =>
                                            setSearch(value)
                                        }
                                        size="small"
                                        className="w-full"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        size="small"
                                                        type="submit"
                                                    >
                                                        <Icon
                                                            size="small"
                                                            color="action"
                                                        >
                                                            search
                                                        </Icon>
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </form>
                            </Grid>
                            <Grid item xs={12}>
                                <ScrollBar className="flex-grow flex-column relative h-full">
                                    <Table className={clsx('whitespace-pre min-w-750')}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    className="w-90 border-b"
                                                >
                                                    No
                                                </TableCell>
                                                <TableCell className='border-b'>Departement[id]</TableCell>
                                                <TableCell className='border-b'>Departement[en]</TableCell>
                                                <TableCell align="center" className='w-90 border-b'>
                                                    Aksi
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {loadingDepartement ? (
                                                <TableRow hover>
                                                    <TableCell
                                                        className="px-0"
                                                        align="center"
                                                        colSpan={4}
                                                    >
                                                        <CircularProgress
                                                            size={25}
                                                            color="primary"
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ) : departement?.length <= 0 ? (
                                                <TableRow hover>
                                                    <TableCell
                                                        className="px-0"
                                                        align="center"
                                                        colSpan={4}
                                                    >
                                                        Data kosong.
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                departement?.map((item, i) => (
                                                    <TableRow
                                                        hover
                                                        key={item.d_code}
                                                    >
                                                        <TableCell
                                                            className="px-0"
                                                            align="center"
                                                        >
                                                            {show * (page - 1) +
                                                                (i + 1)}
                                                        </TableCell>
                                                        <TableCell className="px-0">
                                                            {item.name_id}
                                                        </TableCell>
                                                        <TableCell className="px-0">
                                                            {item.name_en}
                                                        </TableCell>
                                                        <TableCell
                                                            className="px-0"
                                                            align="center"
                                                        >
                                                            <MatxMenu
                                                                menuButton={
                                                                    <div className="flex items-center">
                                                                        <IconButton size="small">
                                                                            <MoreHoriz />
                                                                        </IconButton>
                                                                    </div>
                                                                }
                                                                horizontalPosition="right"
                                                            >
                                                                <MenuItem>
                                                                    <Link
                                                                        to={`/departement_karir/edit/${item.d_code}`}
                                                                        className="popup-menu-item"
                                                                    >
                                                                        <img
                                                                            src="/assets/images/icons/ic_action_edit.svg"
                                                                            alt="icon edit"
                                                                        />
                                                                        <span className="pl-4">
                                                                            {' '}
                                                                            Edit{' '}
                                                                        </span>
                                                                    </Link>
                                                                </MenuItem>
                                                                <MenuItem>
                                                                    <Link
                                                                        to={
                                                                            '/departement_karir' +
                                                                            location?.search
                                                                        }
                                                                        onClick={() =>
                                                                            handleDelete(
                                                                                item.d_code,
                                                                                item.name_id
                                                                            )
                                                                        }
                                                                        className="popup-menu-item"
                                                                    >
                                                                        <img
                                                                            src="/assets/images/icons/ic_action_delete.svg"
                                                                            alt="icon hapus"
                                                                        />
                                                                        <span className="pl-4">
                                                                            {' '}
                                                                            Hapus{' '}
                                                                        </span>
                                                                    </Link>
                                                                </MenuItem>
                                                            </MatxMenu>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </ScrollBar>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} className="mt-2 px-6">
                            <Grid item xs={12} className="flex justify-center justify-content-lg-between items-center">
                                {
                                    loadingDepartement ?
                                        <p className='text-muted m-0 d-none d-lg-block'>Mengambil Data...</p>
                                    :
                                        <p className='text-muted m-0 d-none d-lg-block'>Menampilkan {parseInt(show) * (parseInt(page) - 1) + 1} sampai {parseInt(page) * parseInt(show)} dari {totalDepartement} data</p>
                                }
                                <div className="d-flex justify-content-end container-pagination mt-4 flex-column flex-md-row items-center">
                                    <div className="d-flex align-items-center mb-3">
                                        <p className="m-0 mr-2">Tampilkan</p>
                                        <Form.Select
                                            aria-label="Tampilkan"
                                            className="font-14 border-radius-0"
                                            value={show}
                                            onChange={({ target: { value } }) =>
                                                history.push(
                                                    `/departement_karir?hal=${page}&limit=${value}&cari=${search}`
                                                )
                                            }
                                        >
                                            <option value="100">100</option>
                                            <option value="25">25</option>
                                            <option value="10">10</option>
                                            <option value="5">5</option>
                                        </Form.Select>
                                    </div>
                                    <TablePagination
                                        href="/departement_karir"
                                        page={page}
                                        params={`&limit=${show}&cari=${search}`}
                                        total={departementPagination}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
            <BackdropLoading open={showLoading} />
        </div>
    );
};

export default Departement;
